import React from 'react'
import type { ColumnBlock as BlockProps } from '@/payload-types'
import { RenderBlocks } from '@/blocks/RenderBlocks'

// Maps `span` (string from select) to a Tailwind-flex weight via inline
// style.flexGrow. CSS does the proportional math at the parent level —
// each column claims `span` units of the available row width.
export const ColumnBlock: React.FC<BlockProps> = ({ layout, span }) => {
  const grow = parseInt(span ?? '1', 10) || 1
  return (
    <div className="min-w-0" style={{ flex: `${grow} ${grow} 0%` }}>
      <RenderBlocks blocks={layout ?? []} />
    </div>
  )
}
